<div fxLayout="column" fxLayoutAlign="center center" *ngIf="booking">
    <div class="background-color-white margin-top-2 shadow-large"
         fxLayout="column"
         fxLayout.gt-xs="row"
         fxLayoutAlign="start center"
         fxLayoutAlign.gt-sm="start center">
        <div>
            <img app-imagekit class="display-block full-width"
                 [source]="booking.summary.imageUrl"
                 transform="tr:w-252,h-160">
        </div>

        <div class="padding-2" fxFlex fxLayout="column">
            <div class="text-medium" fxLayoutAlign="start center">
                <span>{{ booking.summary.location.address.city }}, </span>

                <span class="size-05"></span>

                <app-country-code [countryCode]="booking.summary.location.address.countryCode"></app-country-code>
            </div>

            <h4 class="margin-top-05 truncate">{{ booking.summary.name }}</h4>

            <div class="size-2"></div>

            <div fxLayout="row" fxLayoutAlign="start center">
                <div>Checkin:</div>

                <div class="size-2"></div>

                <div>{{ booking.checkin | date:'mediumDate' }}</div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center">
                <div>Checkout:</div>

                <div class="size-2"></div>

                <div>{{ booking.checkout | date:'mediumDate' }}</div>
            </div>
        </div>
    </div>

    <div class="size-5"></div>

    <div fxLayoutGap="20px">
        <label class="text-medium">Your unique booking reference</label>
        <input
                value="{{bookingReference}}"
                appUppercase
                [placeholder]="'E.g. ABC123'"
                [formControl]="nameControl">
    </div>

    <div class="size-5"></div>

    <div fxLayout="row" fxLayoutGap="20px">
        <button (click)="acceptBooking()"
                color="accent"
                flok-button
                [fullWidth]="false"
                [disabled]="loading || !nameControl.valid || nameControl.pristine">Accept
        </button>

        <button (click)="declineBooking()"
                flok-button
                [fullWidth]="false"
                [disabled]="loading || !nameControl.valid || nameControl.pristine">Decline
        </button>
    </div>
</div>
